import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import T from 'utils/useLocalizer';
import { Telephone } from 'react-bootstrap-icons';
import FormLabel from 'components/form/label/FormLabel';
import SelectField from 'components/form/input/SelectField';
import { IWhatsAppNumber } from 'models/whatsAppNumberModel';
import { ISelectItem } from 'models/commonModel';
import { useFormContext } from 'react-hook-form';
import { IOrderSettingsFormData } from 'models/ordersModel';
import { pageRoutes } from 'config/router/pageRoutes';
import { OrderWAPhoneEmptyContext } from './OrderWAPhoneEmptyContext';

export interface Props {
  waPhoneNumbers?: IWhatsAppNumber[];
  isLoading?: boolean;
}
const NotificationSenderForm = ({ waPhoneNumbers, isLoading }: Props) => {
  const navigate = useNavigate();
  const {
    register,
    formState: { errors },
  } = useFormContext<IOrderSettingsFormData>();
  const isDisabled = useContext(OrderWAPhoneEmptyContext);

  const [waSenderIdList, setWaSenderIdList] = useState<ISelectItem<number>[]>([]);

  const resources = {
    notificationSenderLabel: T('orders.order.settings.notification.sender.label'),
    notificationSenderLabelDesc: T('orders.order.settings.notification.sender.label.description'),
    waPhoneNumberDefaultValue: T('orders.order.settings.notification.sender.wa.phone.number.default.value'),
    missingWhatsappPhoneNumberMessage: T('orders.order.settings.notification.sender.missing.whatsapp.phone.number.message'),
    addWAPhoneNumberButtonLabel: T('orders.order.settings.notification.sender.add.whatsapp.phone.number.button.label'),
  };

  useEffect(() => {
    if (waPhoneNumbers && waPhoneNumbers.length > 0) {
      const senderList = waPhoneNumbers.map((item) => ({ label: `\u2066${item.phoneNumber}\u2069 - ${item.verifiedName}`, value: item.id }));      
      setWaSenderIdList(senderList);
    }
  }, [waPhoneNumbers]);
  
  return (
    <div className="border rounded-12 bg-white p-3">
      <div className="d-flex gap-2 align-items-center mb-4">
        <Telephone className="text-muted me-2" />
        <FormLabel label={resources.notificationSenderLabel} labelDesc={resources.notificationSenderLabelDesc} isLabelInline />
      </div>

      <div>
        {isDisabled && !isLoading && (
          <div className="px-2 mb-4">
            <span className="text-muted">
              {resources.missingWhatsappPhoneNumberMessage}{' '}
              <span className="text-primary cursor-pointer text-decoration-underline" onClick={() => navigate(pageRoutes.whatsAppNumbers)}>
                {resources.addWAPhoneNumberButtonLabel}
              </span>
            </span>
          </div>
        )}
      </div>
      <SelectField
        inputProps={{ ...register('waPhoneNumberId') }}
        disabled={isDisabled}
        itemsList={waSenderIdList}
        defaultOptionValue={0}
        customClassName="col-lg-4 mb-2"
        defaultOptionLabel={isDisabled && !isLoading ? resources.waPhoneNumberDefaultValue : ''}
        isLoading={isLoading}
        isError={!!errors.waPhoneNumberId}
        errorMessage={errors.waPhoneNumberId?.message}
      />
    </div>
  );
};

export default NotificationSenderForm;
